<template>
  <div>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="congressEdition"
        :search="search"
        :items-per-page="15"
        :footer-props="{
          itemsPerPageOptions: [15, 30, -1],
          itemsPerPageText: $t('table.itemsPerPageText')
        }"
        sort-by="name"
        class="table-cursor"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('search')"
              single-line
              hide-details
            />
            <v-spacer />
            <v-dialog v-model="dialog" max-width="700px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                  @click="newItem()"
                  ><v-icon class="mr-2">mdi-plus-thick</v-icon
                  >{{ $t("button.newItem") }}</v-btn
                >
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                    <v-form ref="form" class="pa-3">
                      <v-row class="align-center">
                        <v-col cols="11">
                          <v-autocomplete
                            :items="congress"
                            item-text="name"
                            item-value="id"
                            v-model="editedItem.congress"
                            :label="$t('form.congress')"
                            :rules="rules.fieldRequired"
                          ></v-autocomplete>
                        </v-col>
                        <v-col class="align-center" cols="1">
                          <v-btn
                            icon
                            to="/manage/edit/congress"
                            target="_blank"
                            text
                          >
                            <v-icon
                              color="green"
                              v-tooltip.top-center="
                                $t('info.tooltip.addCongress')
                              "
                            >
                              mdi-new-box
                            </v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            v-model="editedItem.name"
                            :label="$t('form.name')"
                            :rules="rules.char_required_max_200"
                            :counter="200"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" md="4">
                          <v-menu
                            v-model="menu_start_date"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="editedItem.start_date"
                                :label="$t('label.startDate')"
                                prepend-inner-icon="event"
                                readonly
                                v-on="on"
                                :rules="rules.fieldRequired"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="editedItem.start_date"
                              @input="menu_start_date = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" sm="12" md="4">
                          <v-menu
                            v-model="menu_end_date"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="editedItem.end_date"
                                :label="$t('label.endDate')"
                                prepend-inner-icon="event"
                                readonly
                                v-on="on"
                                :rules="rules.fieldRequired"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              :min="editedItem.start_date"
                              v-model="editedItem.end_date"
                              @input="menu_end_date = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" sm="12" md="4">
                          <v-text-field
                            v-model="editedItem.year"
                            :label="$t('form.year')"
                            :rules="rules.fieldRequired"
                            type="number"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="editedItem.city"
                            :label="$t('table.city')"
                            :rules="rules.char_max_40"
                            :counter="40"
                          />
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="editedItem.country"
                            :label="$t('table.country')"
                            :rules="rules.char_max_40"
                            :counter="40"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-text-field
                            v-model="editedItem.website"
                            :label="$t('table.website')"
                            :rules="rules.char_max_150"
                            :counter="150"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6" sm="6" md="6">
                          <v-checkbox
                            v-model="editedItem.hidden"
                            :label="$t('form.hidden')"
                          ></v-checkbox>
                        </v-col>
                        <v-col cols="6" sm="6" md="6">
                          <v-checkbox
                            v-model="editedItem.featured"
                            :label="$t('form.featured')"
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="close">{{ $t("button.cancel") }}</v-btn>
                  <v-btn color="primary" @click="save">{{
                    $t("button.save")
                  }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.featured="{ item }">
          <v-icon class="ml-6" v-if="item.featured" color="green">
            mdi-alert-octagram
          </v-icon>
          <v-icon v-else class="ml-6" color="grey">
            mdi-alert-octagram-outline
          </v-icon>
        </template>
        <template v-slot:item.hidden="{ item }">
          <v-icon class="ml-2" v-if="item.hidden" color="red">
            mdi-eye-off
          </v-icon>
          <v-icon v-else class="ml-2" color="grey">
            mdi-eye-outline
          </v-icon>
        </template>
        <template v-slot:item.basic="{ item }">
          <v-icon class="ml-3" v-if="item.basic" color="green">
            mdi-check-circle
          </v-icon>
          <v-icon v-else class="ml-3" color="red">
            mdi-close-circle
          </v-icon>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon class="mr-2" color="primary" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon color="red" @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import validationRules from "../../mixins/validationRules";
export default {
  mixins: [validationRules],
  data() {
    return {
      dialog: false,
      menu_start_date: false,
      menu_end_date: false,
      search: "",
      congress: [],
      congressEdition: [],
      editedIndex: -1,
      editedItem: {
        name: "",
        year: "",
        start_date: "",
        end_date: "",
        city: "",
        country: "",
        website: "",
        hidden: false,
        featured: false
      },
      defaultItem: {
        name: "",
        year: "",
        start_date: "",
        end_date: "",
        city: "",
        country: "",
        website: "",
        hidden: false,
        featured: false
      }
    };
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("title.newItem")
        : this.$t("title.editItem");
    },
    headers() {
      return [
        {
          text: this.$t("table.id"),
          value: "id",
          width: "10%"
        },
        {
          text: this.$t("form.name"),
          value: "name"
        },
        {
          text: this.$t("table.year"),
          value: "year"
        },
        {
          text: this.$t("table.hidden"),
          value: "hidden"
        },
        {
          text: this.$t("table.featured"),
          value: "featured"
        },
        {
          text: this.$t("actions"),
          value: "actions",
          align: "end",
          filterable: false,
          sortable: false
        }
      ];
    }
  },
  created() {
    this.getCongress();
    this.initialize();
  },

  methods: {
    getCongress() {
      let path = this.$store.state.endpoint + "/congress";
      axios
        .get(path)
        .then(response => {
          this.congress = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    initialize() {
      let path = this.$store.state.endpoint + "/congressEdition";
      axios
        .get(path)
        .then(response => {
          this.congressEdition = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    editItem(item) {
      this.editedIndex = this.congressEdition.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.id = item.id;
      this.dialog = true;
    },

    newItem() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.dialog = true;
    },

    deleteItem(item) {
      if (confirm(this.$t("message.confirm.delete"))) {
        let path = this.$store.state.endpoint + "/congressEdition/" + item.id;
        axios
          .delete(path)
          .then(response => {
            const index = this.congressEdition.indexOf(item);
            this.congressEdition.splice(index, 1);
            this.$store.commit("alert", {
              color: "success",
              text: this.$t("message.correct.deleteItem")
            });
          })
          .catch(error => {
            console.log(error);
            this.$store.commit("alert", {
              color: "error",
              text: error.response
            });
          });
      }
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.$refs.form.reset();
      });
    },

    save() {
      if (this.$refs.form.validate()) {
        let path;
        const index = this.editedIndex;
        if (index > -1) {
          path =
            this.$store.state.endpoint +
            "/congressEdition/" +
            this.editedItem.id;
          axios
            .patch(path, this.editedItem)
            .then(response => {
              Object.assign(this.congressEdition[index], response.data);
              this.$store.commit("alert", {
                color: "success",
                text: this.$t("message.correct.updateItem")
              });
            })
            .catch(error => {
              console.log(error);
              this.$store.commit("alert", {
                color: "error",
                text: error.response.data
              });
            });
        } else {
          path = this.$store.state.endpoint + "/congressEdition";
          axios
            .post(path, this.editedItem)
            .then(response => {
              this.congressEdition.push(response.data);
              this.$store.commit("alert", {
                color: "success",
                text: this.$t("message.correct.createItem")
              });
            })
            .catch(error => {
              console.log(error);
              this.$store.commit("alert", {
                color: "error",
                text: error.response.data
              });
            });
        }
        this.close();
      }
    }
  }
};
</script>
